import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/Dropdown'
import '../../css/common/PhoneInput.css';
import { DropdownMenu, Input } from '../../components';

class ValidationCodeInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      current_focus: 'code_1',
      code: '',
    }
  }

  render() {

    var value    = this.props.value || '';
    var onChange = this.props.onChange;
    var style    = this.props.style;
    let invalid  = this.props.invalid || false;
    let code_len = this.props.code_length ? this.props.code_length : 5;

    return<div className={ `flex-container-row` } style={{ }}>
      <Input  className='instant-input-default'
              style={style}
              placeholder='000000'
              value={value}
              ref='validator_input'
              onChange={ (event) => {
                if (event.target.value.length < code_len + 1) {
                  onChange(event.target.value);
                }
                if (event.target.value.length === code_len && this.props.completeAction) {
                  this.refs.validator_input.blur();
                  onChange(event.target.value);
                  this.props.completeAction(event.target.value);
                }
              }}
            />
    </div>
  }

}

export default ValidationCodeInput
